import { useQuery } from '@tanstack/react-query'
import { getHeaders } from 'services/api/utils'
import { findOutWhichEnv, getEnvPath } from 'utils/env'

const env = findOutWhichEnv()
const BASE_URL = `${getEnvPath(env)}/hsmservices/api`

/**
 *
 * @param {Object} filters
 * @param {string[]} filters.wabaId - WABA ID
 * @param {string} filters.search - input search
 * @param {number[]} filters.status - Status
 * @param {number[]} filters.quality - Quality
 * @param {string} filters.tenantId - Tenant ID
 * @returns
 */
async function getQualityNumberList(filters) {
  try {
    const { wabaId, search, status, quality, page, pageSize, tenantId } = filters

    if (!tenantId) {
      throw new Error("Tenant wasn't found")
    }

    const params = new URLSearchParams()
    if (search) params.append('search', search)
    if (wabaId?.length) {
      wabaId.forEach((item) => {
        params.append('wabaId', item)
      })
    }
    if (status?.length) {
      status.forEach((item) => {
        params.append('status', item)
      })
    }
    if (quality?.length) {
      quality.forEach((item) => {
        params.append('qualityRating', item)
      })
    }
    if (page) params.append('page', page)
    if (pageSize) params.append('pageSize', pageSize)
    if (tenantId) params.append('tenantId', tenantId)
    const queryString = params.toString()

    let url = `${BASE_URL}/accounts`

    if (queryString) {
      url = `${BASE_URL}/accounts?${queryString}`
    }

    const response = await fetch(url, getHeaders('GET'))

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    return await response.json()
  } catch (error) {
    console.error('Error fetching data:', error)

    return {
      data: [],
      error: true,
      message: 'No data found',
      status: 'error',
    }
  }
}

export const QUERY_QUALITY_NUMBER_KEY = 'get-quality-number-list'

const useGetQualityNumberList = ({ wabaId, search, status, quality, page, pageSize, tenantId, enabled = true }) => {
  return useQuery({
    queryKey: [QUERY_QUALITY_NUMBER_KEY, { wabaId, search, status, quality, page, pageSize, tenantId }],
    queryFn: () => getQualityNumberList({ wabaId, search, status, quality, page, pageSize, tenantId }),
    select: (data) => data,
    retry: 1,
    keepPreviousData: true,
    staleTime: 1 * (60 * 1000), // 1 mins
    cacheTime: 2 * (60 * 1000), // 2 mins
    enabled,
  })
}

export default useGetQualityNumberList
